import React from 'react';
import { rowAccent } from '../utils/rowAccent';

// Flag kinds used to colour-code rows in the Payroll Entry Summary table.
export const FLAG_KINDS = ['starter', 'leaver', 'warn', 'recent', 'backpay', 'addition', 'change', 'note'];

const BADGE_STYLES = {
  starter: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  leaver:  'bg-rose-50 text-rose-800 ring-rose-200',
  warn:    'bg-amber-50 text-amber-800 ring-amber-200',
  recent:  'bg-sky-50 text-sky-800 ring-sky-200',
  backpay: 'bg-orange-50 text-orange-800 ring-orange-300',
  addition: 'bg-teal-50 text-teal-800 ring-teal-300',
  change:  'bg-amber-50 text-amber-800 ring-amber-200',
  note:    'bg-violet-50 text-violet-800 ring-violet-200',
};

// Re-exported so existing importers (e.g. SummaryTable) keep working; the
// implementation now lives in utils/rowAccent.js as the single source of truth.
export { rowAccent };

export default function FlagBadge({ flag, size = 'md' }) {
  if (!flag) return null;
  const cls = BADGE_STYLES[flag.kind] || BADGE_STYLES.warn;
  const sizing = size === 'sm'
    ? 'px-2 py-0.5 text-[13.5px]'
    : 'px-2.5 py-1 text-[14.5px]';
  return (
    <span className={`inline-flex items-center rounded-md font-medium ring-1 ${sizing} ${cls}`}>
      {flag.label}
    </span>
  );
}
